import { Alert, BackHandler, Dimensions, Linking } from "react-native";
import {
  API_URL,
  REDIRECT_URL,
  API_URL_MOBILE,
  API_CONTROLLER_NAME,
} from "@env";
import { web, android, ios } from "./Platform";
import { gtag, install } from "ga-gtag";
import { gTagId, gTagAddId } from "@env";
import XMLParser from "react-xml-parser";
import moment from "moment";
import AsyncStorage from "@react-native-async-storage/async-storage";
import packageJson from "../../package.json";

let analytics;
if (!__DEV__) {
  analytics = require("@react-native-firebase/analytics").default;
} else {
  analytics = {
    logEvent: () => console.log("Event logged in development"),
  };
}

const handleAPI = async ({
  name,
  params,
  method,
  requestOptions = null,
  apiName = null,
}) => {
  let url = API_URL;

  params = Object.keys(params)
    .map(
      (key) => `${key}=${params[key]?.toString()?.replaceAll("&", "U00026")}`
    )
    .join("&");

  if (!web) {
    url = API_URL_MOBILE;
  } else if (
    window.location.host === "localhost:19006" ||
    window.location.host.startsWith("192.168.") ||
    window.location.host.includes("preview.directmortgage.com")
  ) {
    url = API_URL_MOBILE.replace(
      "https://www.directcorp.com",
      "https://www.solutioncenter.biz"
    );
  }
  if (apiName) {
    url = url.replace(API_CONTROLLER_NAME, apiName);
  }
  try {
    return fetch(
      `${url}${name}?${params}`,
      requestOptions
        ? requestOptions
        : {
            method: method || "POST",
            mode: "cors",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
    )
      .then(async function (response) {
        let res = await response.json();
        // if (
        //   __DEV__ &&
        //   name === "GetBorrowerRedirectURLs" &&
        //   params.includes("486206")
        // ) {
        //   res = res.split("~");
        //   res[0] =
        //     "../../../Esignature/Presentation/Webforms/ESignShoppingCart_bootstrap_new.aspx?" +
        //     params +
        //     "&sType=3";
        //   res = res.join("res");
        // }
        return res;
      })
      .catch(function (err) {
        console.log(`Error from handleAPI ====>  ${err}`);
      });
  } catch (error) {}
};
const handleUserDetails = async (SessionId) => {
  return await handleAPI({
    name: "GetUsersDetails", //GetUsersDetailsNewLoanApp",
    params: { SessionId: SessionId },
  })
    .then(function (response) {
      return response;
    })
    .catch(function (err) {
      console.log(`Error from handleUserDetails ====>  ${err}`);
    });
};
const handleSessionCheck = async (SessionId, handleLogOut) => {
  if (SessionId) {
    const response = await handleAPI({
      name: "GetUsersDetails",
      params: { SessionId: SessionId },
    })
      .then(function (iResponse) {
        return iResponse;
      })
      .catch(function (err) {
        console.log(`Error from handleSessionCheck ====>  ${err}`);
      });
    let response_ = response.split("~");

    if (response_[0] <= 0) {
      handleLogOut();
    }

    return response_[0];
  }
};
const handleGetEmpDetails = async (SessionId) => {
  if (SessionId) {
    return await handleAPI({
      name: "GetSessionData",
      params: { SessionId: SessionId },
    })
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        console.log(`Error from handleSessionCheck ====>  ${err}`);
      });
  }
};
const FormatPhoneLogin = (PhoneNo) => {
  try {
    if (PhoneNo != "") {
      PhoneNo = PhoneNo.replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "");
      if (PhoneNo.indexOf("@") == -1) {
        PhoneNo = PhoneNo.replaceAll("-", "");
        PhoneNo = PhoneNo.slice(0, 10);
      } else {
      }

      if (
        PhoneNo.indexOf("@") == -1 &&
        Number(PhoneNo) &&
        PhoneNo.length === 10
      ) {
        PhoneNo = PhoneNo.replace(/D/g, "");
        if (PhoneNo.length < 10) {
          return PhoneNo;
        }

        let p = /^([\d]{3})([\d]{3})([\d]{4,})$/.exec(PhoneNo);

        PhoneNo = "(" + p[1] + ") " + p[2] + "-" + p[3];
        return PhoneNo;
      }
    }
  } catch (error) {
    console.error("Error form FormatPhoneLogin ===> ", error);
  }
  return PhoneNo;
};
const handleOpenURL = async (url) => {
  // url = url.replace("../../../", REDIRECT_URL);
  url = url
    .replace("https://www.directcorp.com/", "../../../")
    .replace("https://www.solutioncenter.biz/", "../../../")
    .replace("http://www.solutioncenter.biz/", "../../../");
  // console.log(url, supported);
  let supported = await Linking.canOpenURL(url);
  if (supported) {
    await Linking.openURL(url);
  } else {
    Alert.alert(`Don't know how to open this URL: ${url}`);
  }
};
const validateEmail = (text) => {
  //Validating the email
  let regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(text);
};

const log = (text, msg) => {
  __DEV__ && console.log(`${text} ====> `, msg);
};
const handleCreateLoanOnly = (SessionId, navigation, userName) => {
  handleAPI({
    name: "CreateLoanOnly",
    params: { sessionid: SessionId, empid: 1, EventId: 15 },
  })
    .then((response) => {
      response = JSON.parse(response);
      updateWebURL({
        SessionId: SessionId,
        loanId: response,
        Path: "Home",
      });
      navigation.navigate("Home", {
        userName: userName,
        SessionId: SessionId,
        loanId: response,
      });
    })
    .catch((error) => console.error("Error from CreateLoanOnly ====> ", error));
};
// const formatCurrency = (value, decPlaces, sign_ = true) => {
//   let num = value?.toString().replaceAll("$", ""),
//     multiplier = Math.pow(10, decPlaces),
//     rounder = 50 / multiplier + 0.00000000001,
//     i = 0,
//     cents = num % multiplier,
//     sign = num == (num = Math.abs(num));

//   num = num.toString().replace(/\$|\,/g, "");
//   if (isNaN(num)) num = "0";
//   if (isNaN(decPlaces)) num = "2";

//   num = Math.floor(num * multiplier + rounder);
//   num = Math.floor(num / multiplier).toString();

//   for (i = 1; i < decPlaces; i++) {
//     if (cents < Math.pow(10, i)) cents = "0" + cents;
//   }
//   for (i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
//     num =
//       num.substring(0, num.length - (4 * i + 3)) +
//       "," +
//       num.substring(num.length - (4 * i + 3));
//   if (sign_) return "$" + num;
//   return "$" + ((sign ? "" : "-") + num);
// };

const formatCurrencyOld = (value) => {
  let num = parseFloat(
      (value || "").toString().replace("$", "").replace(",", "")
    ).toString(),
    numParts = num.split("."),
    dollars = numParts[0],
    cents = numParts[1] || "",
    sign = num == (num = Math.abs(num));
  dollars = dollars.replace(/\$|\,/g, "");
  if (isNaN(dollars)) dollars = "0";
  dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let val = "$" + ((sign ? "" : "-") + dollars + (cents ? "." + cents : ".00"));
  val = val.replaceAll("--", "-");
  if (val == "$-0.00") val = "$0.00";
  return val;
};
const formatCurrency = (value, floatCount = 2) => {
  let num = parseFloat(
      (value || "").toString().replace("$", "").replace(",", "")
    )
      ?.toFixed(floatCount)
      .toString(),
    numParts = num.split("."),
    dollars = numParts[0],
    cents = numParts[1] || "",
    sign = num == (num = Math.abs(num));
  dollars = dollars.replace(/\$|\,/g, "");
  if (isNaN(dollars)) dollars = "0";
  dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let val =
    "$" +
    ((sign ? "" : "-") +
      dollars +
      (floatCount ? (cents ? "." + cents : ".00") : ""));
  val = val.replaceAll("--", "");
  if (["$-0.00", "$-0"].includes(val)) val = "$0.00";
  return val;
};
const roundNumber = (number, decimals) => {
  try {
    let newnumber = new Number(number + "").toFixed(parseInt(decimals));
    if (newnumber.indexOf(".") < 0) {
      newnumber = newnumber + ".";
      for (i = 0; i < decimals; i++) {
        newnumber = newnumber + "" + "0";
      }
    } else {
      let nNum = newnumber.split(".");
      for (let i = nNum[1].length; i < decimals; i++) {
        newnumber = newnumber + "" + "0";
      }
    }
    return parseFloat(newnumber);
  } catch (e) {}
};
const cleanValue = (sVal) => {
  try {
    sVal = sVal
      .replaceAll("$", "")
      .replaceAll(",", "")
      .replaceAll("%", "")
      .replaceAll("-", "");
    if (sVal == "") sVal = 0;
  } catch (e) {}
  return sVal;
};
const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const getQueryString = (key, default_) => {
  let finalQueryString = "";
  if (default_ == null) default_ = "";
  key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  let NewKey = key.toUpperCase(),
    regex = new RegExp("[\\?&]" + NewKey + "=([^&#]*)"),
    ActualQueryString = window.location?.href || "",
    NewQueryString = ActualQueryString.toUpperCase(),
    qsValue = regex.exec(NewQueryString);
  if (qsValue != null) {
    let startPosi = NewQueryString.indexOf(NewKey),
      keylen = NewKey.length,
      Querylen = ActualQueryString.length,
      prefix = ActualQueryString.substring(0, startPosi),
      sufix = ActualQueryString.substring(startPosi + keylen, Querylen);
    finalQueryString = prefix + NewKey + sufix;
  } else {
    finalQueryString = NewQueryString;
  }
  let qs = regex.exec(finalQueryString),
    returnValue = default_;
  if (qs == null) returnValue = default_;
  else returnValue = qs[1];
  if (web) return returnValue || queryStringToObject()[key];
  else return returnValue;
};
const queryStringToObject = (queryString) => {
  if (!queryString) queryString = window.location.href;
  queryString = queryString.split("?")[1];
  const params = new URLSearchParams(queryString),
    result = {};
  for (const [key, value] of params) {
    result[key] = value;
  }
  return result;
};
async function updateWebURL(params, flag) {
  if (web) {
    let queryString = new URLSearchParams(window.location?.search || ""),
      exception = false;
    if (params !== undefined) {
      for (const [key, value] of Object.entries(params)) {
        if (value && key !== "navigation") {
          //key === "Path" || key === "SessionId") -- removed for web login -> dashboard
          queryString.set(key, value);
        } else {
          queryString.delete(key);
        }
      }
    } else {
      queryString = queryString
        .toString()
        .split("&")
        .filter((e) => e.toString().indexOf("Path") === -1)
        .join("&");
      exception = true;
    }
    let newUrl = `${window.location.pathname}`;
    if ((params && ["Login"].indexOf(params.Path) === -1) || exception)
      newUrl = `${window.location.pathname}?${queryString
        .toString()
        .replace("%7B", "{")
        .replace("%7D", "}")}`;

    if (newUrl.indexOf("DashBoard") > -1)
      newUrl = newUrl
        .toString()
        .split("&")
        .filter(
          (e) =>
            e.toString().indexOf("userName") > -1 ||
            e.toString().indexOf("Path") > -1 ||
            e.toString().indexOf("SessionId") > -1
        )
        .join("&");
    if (flag) return newUrl;

    window.history.replaceState(null, "", newUrl);
  }
}
function getQueryStringURL(key, default_, URL) {
  let finalQueryString = "";
  if (default_ == null) default_ = "";
  key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

  let NewKey = key.toUpperCase();
  NewKey = NewKey.replace("=", "");
  let regex = new RegExp("[\\?&]" + NewKey + "=([^&#]*)"),
    ActualQueryString = URL,
    NewQueryString = ActualQueryString.toUpperCase(),
    qsValue = regex.exec(NewQueryString);
  if (qsValue != null) {
    let startPosi = NewQueryString.indexOf("&" + NewKey),
      keylen = NewKey.length,
      Querylen = ActualQueryString.length,
      prefix = ActualQueryString.substring(0, startPosi),
      sufix = ActualQueryString.substring(startPosi + 1 + keylen, Querylen),
      finalQueryString = prefix + "&" + NewKey + sufix;
  } else {
    finalQueryString = NewQueryString;
  }
  let qs = regex.exec(finalQueryString);
  if (qs == null) return default_;
  else return qs[1];
}
const removeDuplicates = (array, property) => {
  const uniqueValues = {};
  return array.filter((obj) => {
    if (!uniqueValues[obj[property]]) {
      uniqueValues[obj[property]] = true;
      return true;
    }
    return false;
  });
};

// const formatDateTimeNew2 = (input) => {
//   if (!input || input.trim() === "") return "";

//   const currentYear = new Date().getFullYear().toString();

//   // Handle inputs progressively based on length
//   if (/^\d{1,2}$/.test(input)) {
//     // If MM is provided (1-2 digits)
//     return input.padStart(2, "0");
//   } else if (/^\d{3,4}$/.test(input)) {
//     // If MMDD is provided (3-4 digits)
//     const month = input.slice(0, 2).padStart(2, "0");
//     const day = input.slice(2, 4).padStart(2, "0");
//     return `${month}/${day}/${currentYear}`;
//   } else if (/^\d{5,8}$/.test(input)) {
//     // If MMDDYYYY is provided (5-8 digits)
//     const month = input.slice(0, 2).padStart(2, "0");
//     const day = input.slice(2, 4).padStart(2, "0");
//     const year = input.slice(4).padStart(4, currentYear.slice(0, 2));
//     return `${month}/${day}/${year}`;
//   } else if (/^\d{1,2}\/\d{1,2}(\/\d{1,4})?$/.test(input)) {
//     // If input is partially formatted as MM/DD or MM/DD/YYYY
//     const parts = input.split("/");
//     const month = parts[0].padStart(2, "0");
//     const day = (parts[1] || "").padStart(2, "0");
//     let year = parts[2] || currentYear;

//     if (year.length === 2) {
//       year = currentYear.slice(0, 2) + year;
//     }
//     return `${month}/${day}/${year}`;
//   }

//   // Default case for invalid or unexpected input
//   return input;
// };
const formatDateTimeNew2 = (input) => {
  if (!input || input.trim() === "") return "";

  const currentYear = new Date().getFullYear().toString();

  // Handle ISO date string like "2025-07-11T14:39:05.328Z"
  if (!isNaN(Date.parse(input))) {
    const date = new Date(input);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  // Handle inputs progressively based on length
  if (/^\d{1,2}$/.test(input)) {
    return input.padStart(2, "0");
  } else if (/^\d{3,4}$/.test(input)) {
    const month = input.slice(0, 2).padStart(2, "0");
    const day = input.slice(2, 4).padStart(2, "0");
    return `${month}/${day}/${currentYear}`;
  } else if (/^\d{5,8}$/.test(input)) {
    const month = input.slice(0, 2).padStart(2, "0");
    const day = input.slice(2, 4).padStart(2, "0");
    const year = input.slice(4).padStart(4, currentYear.slice(0, 2));
    return `${month}/${day}/${year}`;
  } else if (/^\d{1,2}\/\d{1,2}(\/\d{1,4})?$/.test(input)) {
    const parts = input.split("/");
    const month = parts[0].padStart(2, "0");
    const day = (parts[1] || "").padStart(2, "0");
    let year = parts[2] || currentYear;

    if (year.length === 2) {
      year = currentYear.slice(0, 2) + year;
    }
    return `${month}/${day}/${year}`;
  }

  return input;
};

const formatDateTimeNew = (date) => {
  return formatDateTimeNew2(date);
  if (date === "" || !date) return "";
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString();

  let [month, day, year] = date.split("/");

  if (!day) {
    day = month;
    month = currentDate.getMonth() + 1;
  }

  const parsedMonth = parseInt(month);
  const parsedDay = parseInt(day);

  const isValidMonth =
    !isNaN(parsedMonth) && parsedMonth >= 1 && parsedMonth <= 12;
  const isValidDay = !isNaN(parsedDay) && parsedDay >= 1 && parsedDay <= 31;

  if (!isValidMonth || !isValidDay) {
    const formattedCurrentMonth = (currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const formattedCurrentDay = currentDate
      .getDate()
      .toString()
      .padStart(2, "0");
    return `${formattedCurrentMonth}/${formattedCurrentDay}/${currentYear}`;
  }

  if (year && year.length === 2) {
    year = currentYear.slice(0, 2) + year;
  } else if (!year) {
    year = currentYear;
  }

  const formattedMonth = parsedMonth.toString().padStart(2, "0");
  const formattedDay = parsedDay.toString().padStart(2, "0");

  return `${formattedMonth}/${formattedDay}/${year}`;
};
function formatSSN(SSN) {
  SSN = SSN?.toString().replaceAll("-", "");
  if (SSN.length == "9" && !isNaN(SSN)) {
    var a = SSN.substring(0, 3);
    var b = SSN.substring(3, 5);
    var c = SSN.substring(5, 9);

    return a + "-" + b + "-" + c;
  } else if (isNaN(SSN)) {
    return "";
  }
}
const handleStartNewLoan = (
  navigation,
  SessionId,
  userName,
  contextDetails,
  setContextDetails
) => {
  setContextDetails({
    ...contextDetails,
    ...{ loanId: -999, Path: "Home" },
  });
  updateWebURL({
    SessionId: SessionId,
    loanId: -999,
    Path: "Home",
  });
  navigation.navigate("Home", {
    userName: userName,
    SessionId: SessionId,
    loanId: -999,
  });
};
const sortByKey = (obj, key) => {
  obj = obj.sort((a, b) => a[key].toString().localeCompare(b[key].toString()));
  return obj;
};
const sortByKeyNumber = (arr, key, asc = true) => {
  return arr.sort((a, b) => {
    const numA = Number(a[key]),
      numB = Number(b[key]);
    return asc ? numA - numB : numB - numA;
  });
};

const groupByKey = (input, key) => {
  // input = sortByKey(input, "CustId");
  let data = input.reduce((acc, currentValue) => {
    let groupKey = currentValue[key];
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(currentValue);
    return acc;
  }, {});

  data = Object.keys(data).map((key) => {
    return {
      Name: key,
      subMenu: data[key].map((iItem) => {
        return { Name: iItem["subName"], Id: iItem["Id"] };
      }),
    };
  });
  return data;
};
const handleCheckObj = (obj) => {
  for (const key in obj) {
    if (!obj[key] && obj[key] != 0) {
      return false;
    }
  }
  if (!Object.keys(obj).length) {
    return false;
  }
  return true;
};

if (web) {
  install(gTagId); // initialize for tracking Event on GA
  install(gTagAddId); // initialize for tracking Event on GA for Ads
}

const handleTrackGA4Events = async (eventName, eventOption) => {
  eventName = (eventName || "").replaceAll(" ", "_");

  if (eventName && handleCheckObj(eventOption)) {
    try {
      if (!__DEV__) {
        if (web) {
          gtag("event", eventName, eventOption);
        } else {
          // console.log("Mobile GA Event", eventName, eventOption);
          logEvent(eventName, eventOption);
        }
      }
    } catch (error) {
      console.error("Error during send event to GA", error);
    }
  }
};
const isFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};
const logEvent = async (eventName, eventOption) => {
  if (analytics) {
    await analytics().logEvent(eventName, eventOption);
  }
};
const handleGetBrowserName = () => {
  var ua = navigator.userAgent;
  var tem;
  var M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

  return M[0]; //.join(" ");
};

const handleLogDWCallToActionEventParent = async (
  Buttontext,
  apiName,
  PageTitle,
  detailsJson,
  currentPage
) => {
  let DeviceId = JSON.parse((await AsyncStorage.getItem("DeviceId")) || null),
    PageLoadId = JSON.parse(
      (await AsyncStorage.getItem(
        apiName === "LogDWVisitorsEvent" ? "iPageLoadId" : "PageLoadId"
      )) || null
    ),
    params = {
      PageTitle: web ? PageTitle || document.title : "Go Direct",
      PageURL: web
        ? window?.parent?.location.href || window.location.href
        : "Go Direct - " + currentPage || "Go Direct",
      device: web ? "desktop" : "mobile",
      IPAddress: DeviceId || 0,
      ParentId: web
        ? window?.parent?.GLO_PageLoadId || PageLoadId
        : PageLoadId || 0,
      Buttontext,
    };

  params["detailsJson"] = JSON.stringify([
    {
      ...detailsJson,
      ...{
        Browser: web ? handleGetBrowserName() : "Go Direct",
      },
    },
  ]);

  // log(apiName, params);
  if (Buttontext !== "" && !__DEV__) {
    handleTrackGA4Events(Buttontext, params);
    return await handleAPI({
      name: apiName,
      params,
    })
      .then((PageLoadId) => {
        if (apiName === "LogDWVisitorsEvent") {
          AsyncStorage.setItem(
            "PageLoadId",
            JSON.stringify(PageLoadId || null)
          );
        }
      })
      .catch((e) => log("Error form " + apiName + " ====> ", e));
  }
};
const handleGetButtonText = (loginFrom) => {
  let Buttontext = "",
    documentURI = document.documentURI;
  if (
    documentURI.includes("StartLoanApp=1") ||
    documentURI.includes("To=loanapp")
  )
    Buttontext = "Start a Loan Application";
  else if (documentURI.includes("LockThisRate=1"))
    Buttontext = "Lock This Interest Rate";
  else if (documentURI.includes("RateOptions=1"))
    Buttontext = "View All Fees and Rate Options";
  else if (documentURI.includes("CustomizeOptions=1"))
    Buttontext = "Customize Your Scenario";
  else if (documentURI.includes("To=ratequote")) Buttontext = "Rate Quote";
  else if (documentURI.includes("To=securedoc"))
    Buttontext = "Upload Documents";
  else if (documentURI.includes("To=ratewizard&RateQuoteId=undefined"))
    Buttontext = "Track these Rates";
  else if (loginFrom === "securedoc") Buttontext = "Upload Documents";
  else if (loginFrom === "loanapp") Buttontext = "Apply Online";

  return Buttontext;
};
const handleGetStoredCredential = async () => {
  //Reading AsyncStorage to getting details for Auto re-directing
  let Credentials = null;
  await AsyncStorage.getItem("Credentials")
    .then((result) => {
      if (result !== null) {
        result = JSON.parse(result);
        if (Number(result.AutoRedirectExpiryDate) < new Date().getTime()) {
          AsyncStorage.removeItem("Credentials");
          Credentials = null;
        } else {
          Credentials = result;
        }
      } else {
        Credentials = result;
      }
    })
    .catch((error) => {
      log("Error from handleGetStoredCredential ====> ", error);
    });
  return Credentials;
};
const handleCreateNewSession = async (WebLoginId) => {
  return await handleAPI({
    name: "CreateSessionWrapper",
    params: { WebLoginId },
  }).then((response) => {
    response = response.split("~");
    return response[0];
  });
};
const handleSetStoredCredential = (flag, logDetails) => {
  //Storing requied details for auto redirecting
  if (flag === 1) {
    let {
        WebLoginId,
        UserDisplayName,
        URL,
        EmailOutside,
        Emailoutside,
        CellPhone,
        UserName,
        SessionId,
        DeviceId,
        UserType,
      } = logDetails,
      date = new Date();
    date.setDate(date.getDate() + 30);

    let objectToStore = JSON.stringify({
      WebLoginId: WebLoginId,
      UserDisplayName: UserDisplayName,
      URL: URL,
      UserName: EmailOutside || Emailoutside || UserName || CellPhone,
      AutoRedirectExpiryDate: date.getTime(),
      AutoRedirect: true,
      DeviceId,
      SessionId,
      UserType,
    });
    AsyncStorage.removeItem("Credentials");
    AsyncStorage.setItem("Credentials", objectToStore || null);
  }
  //Clearing the sortage
  else if (flag === 2) AsyncStorage.removeItem("Credentials");
};
const handleCheckAlreadyLogIn = async () => {
  let logDetails = await handleGetStoredCredential();
  if (logDetails !== null) {
    const isActiveSession = await handleSessionCheck(
      logDetails["SessionId"],
      () => {}
    );
    if (isActiveSession == 0) {
      let sessionId = await handleCreateNewSession(logDetails["WebLoginId"]);
      logDetails["SessionId"] = sessionId;
    }
    handleSetStoredCredential(1, logDetails);

    return logDetails;
  }
};
const getNextNoYear = (length) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: length + 1 }, (_, index) => {
    let nextYear = currentYear + index;
    return {
      value: parseInt(nextYear.toString().slice(2, 4)),
      label: nextYear,
    };
  });
  return years;
};
const handleGetZipCodeDetails = async (zipCode) => {
  if (zipCode.length !== 5) return { city: "", state: "0" };
  return await handleAPI({
    name: "GetZipcodedetails",
    params: { Zipcode: zipCode },
  })
    .then((response) => {
      response = new XMLParser().parseFromString(response);
      response = response.children[0]["children"];
      let city = response[2]["value"],
        state = response[0]["value"];
      return { city, state };
    })
    .catch((e) => console.error("Error from GetZipcodedetails ====> ", e));
};
const handleOpenPageURL = (url, Width, Height, Name) => {
  try {
    if (web) {
      const params = [
        "toolbar=0",
        "location=0",
        "directories=0",
        "status=0",
        "menubar=0",
        "scrollbars=1",
        `width=${Width}`,
        `height=${Height}`,
        "left=2",
        "top=2",
        "resizable=1",
      ].join(",");

      const win = window.open(url, Name, params);
      win?.focus();
    }
  } catch (error) {}
};

function hashString(input) {
  let hash = 0;
  if (input.length === 0) return hash;

  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  return hash;
}

const updateScreenSize = () => {
  return Dimensions.get("window").width * Dimensions.get("window").height;
};

//async function generateFingerprint() {
function generateFingerprint() {
  try {
    const userAgent = android
      ? "android"
      : ios
      ? "iOS"
      : handleGetBrowserName(); // Adjust this based on your app's details
    const language = "en-US"; // Adjust this based on your app's default language
    const platform = web ? "Web" : "Mobile"; // Adjust this based on your app's platform
    const timezoneOffset = new Date().getTimezoneOffset();
    const screenResolution = updateScreenSize(); // React Native does not provide direct screen resolution

    const fingerprintString = `${userAgent}${language}${platform}${timezoneOffset}${screenResolution}`;
    const fingerprint = hashString(fingerprintString);

    return fingerprint.toString();
  } catch (error) {
    console.error("Error generating fingerprint:", error);
    return null;
  }
}
function getInitials(name) {
  const words = name.split(" ");
  const initials = words
    .map((word) => word.charAt(0))
    .splice(0, 2)
    .join("")
    .toUpperCase();
  return initials;
}
function getObjectsWithKeyword(data, keyword) {
  const objectsWithKeyword = [];
  for (const item of data) {
    if (item.title.toLowerCase().includes(keyword.toLowerCase())) {
      objectsWithKeyword.push(item);
    }

    for (const detail of item.contactDetails) {
      for (const value of Object.values(detail)) {
        if (
          typeof value === "string" &&
          value.toLowerCase().includes(keyword.toLowerCase())
        ) {
          objectsWithKeyword.push(item);
        }
      }
    }
  }

  return objectsWithKeyword;
}
const generateBoxShadowStyle = (
  xOffset,
  yOffset,
  shadowColorIos,
  shadowOpacity,
  shadowRadius,
  elevation,
  shadowColorAndroid
) => {
  let boxShadow;
  if (ios) {
    boxShadow = {
      shadowColor: shadowColorIos,
      shadowOpacity,
      shadowRadius,
      shadowOffset: { width: xOffset, height: yOffset },
    };
  } else if (android) {
    boxShadow = { elevation, shadowColor: shadowColorAndroid };
  } else if (web) {
  }
  return boxShadow;
};
function capitalizeFirstLetter(str) {
  if (typeof str !== "string") {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const handleGetPlatformName = () => {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  if (isIOS) {
    return "iOS";
  } else if (isAndroid) {
    return "Android";
  } else {
    return "Desktop";
  }
};
function calculateAge(birthDate) {
  try {
    const currentDate = moment();
    birthDate = moment(birthDate, "MM/DD/YYYY");

    let age = currentDate.diff(birthDate, "years");

    return age || 0;
  } catch (error) {
    console.error(error.message);
  }
}
const handleOpenScanDocFile = async (SessionId, docid) => {
  let url = "";
  await handleAPI({
    name: "GetScandocManager",
    params: { ScanDocId: docid },
  })
    .then(async () => {
      await handleAPI({
        name: "GetScanDocHistoryDetails",
        params: { ScandocId: docid, SessionId, GatherId: 0 },
      })
        .then((fileName) => {
          // fileName = fileName["Table"][0]["ImagePath"];
          url = `${web ? "../../../" : REDIRECT_URL}PDF/${fileName}`;
        })
        .catch((e) =>
          console.log("Error Form GetScanDocHistoryDetails ====>", e)
        );
    })
    .catch((e) => console.log("Error Form GetScandocManager ====>", e));
  return url;
};

const handleStructuredClone = (data) => {
  return JSON.parse(JSON.stringify(data));
};

const handleGetSubjectPropertyAddress = async (LoanId) => {
  return await handleAPI({
    name: "getloandetails",
    params: {
      LoanId,
    },
  })
    .then((response) => {
      response = JSON.parse(response || '{"contactinfo":[{}]}');

      let {
        subjectaddress: subjectAddress = "",
        subjectcity: subjectCity = "",
        subjectstate: subjectState = "",
        subjectzip: subjectZip = "",
        ssn = "",
        firstname = "",
        lastname = "",
        PhoneNumber = "",
      } = response["contactinfo"][0];

      return {
        subjectAddress,
        subjectCity,
        subjectState,
        subjectZip,
        ssn,
        firstname,
        lastname,
        PhoneNumber,
      };
    })
    .catch((e) => console.error("Error Form getloandetails ====> ", e));
};
const handleGetActiveLoan = async (sessionid) => {
  return await handleAPI({
    name: "CheckActiveLoans",
    params: { sessionid },
  })
    .then((response) => {
      let parseXMLArr = [];
      if (response.indexOf("root") > -1) {
        let parseXML = new XMLParser().parseFromString(response, "text/xml");
        parseXMLArr = parseXML["children"].map((row) => {
          return row["attributes"];
        });
        parseXMLArr = parseXMLArr.filter(
          (loanData) => loanData["status"] == "Active"
        );
        return {
          activeLoanCount: parseXMLArr?.length,
          activeLoanId: parseXMLArr[0]?.["LoanId"] || 0,
        };
      }
    })
    .catch((e) => log("Error from CheckActiveLoans ====>", e));
};
const handleSelectLoanProgram = async (LoanId, callBack = () => {}, status) => {
  //return; // commented for now as it causing issues
  if (!["selected", "selectingInProgress"].includes(status)) {
    callBack("selectingInProgress");
    return await handleAPI({
      name: "RunLoanSelection_NewLoan",
      params: {
        LoanId,
      },
    })
      .then((response) => {
        setTimeout(() => {
          callBack("selected");
        }, 1000);
        return "selected";
      })
      .catch((err) =>
        console.error("Error form RunLoanSelection_NewLoan ====> ", err)
      );
  }
};
const WrappedTextView = ({ text, maxLength }) => {
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};
function isDate(dateStr) {
  let datePat = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/,
    matchArray = dateStr.match(datePat); // is the format ok?

  if (matchArray == null) {
    datePat = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{2})$/;
    matchArray = dateStr.match(datePat); // is the format ok?
    if (matchArray == null) {
      return false;
    }
  }

  let month = matchArray[1], // p@rse date into variables
    day = matchArray[3],
    year = matchArray[5];
  if (month < 1 || month > 12) {
    return false;
  }

  if (day < 1 || day > 31) {
    return false;
  }

  if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
    return false;
  }

  if (month == 2) {
    // check for february 29th
    var isleap = year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
    if (day > 29 || (day == 29 && !isleap)) {
      return false;
    }
  }
  return true;
}
function calculateEmploymentYears(EmpFrom, EmpTo) {
  try {
    if (isDate(EmpFrom) && isDate(EmpTo)) {
      return GetYearDiff(new Date(EmpFrom), new Date(EmpTo));
    }
  } catch (e) {
    console.error("CalculateEmploymentYears ===> " + e.message);
  }
}
function GetYearDiff(date1, date2) {
  try {
    let months = monthDiff(date1, date2);
    months = (months / 12).toFixed(1);
    if (months < 0) {
      months = 0;
    }
    return months;
  } catch (e) {
    console.error("GetYearDiff ===> " + e.message);
  }
}
function monthDiff(d1, d2) {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months += d2.getMonth() - d1.getMonth();
  return months;
}
function convertToArrayCategory(arr) {
  let categories = [];

  const ranges = [
    { min: 0, max: 3 },
    { min: 3, max: 7 },
    { min: 7, max: 11 },
    { min: 11, max: 15 },
    { min: 15, max: 19 },
    { min: 19, max: 23 },
    { min: 23, max: 27 },
  ];

  for (let i = 0; i < arr.length; i += 4) {
    let set = arr.slice(i, i + 4);
    ranges.forEach((range, index) => {
      if (set.some((val) => val >= range.min && val < range.max)) {
        categories.push(index);
      }
    });
  }

  return [...new Set(categories)];
}
const testSSN = (value = "") => {
  return value?.toString().replace(/-/g, "")["length"] !== 9;
};

const getKeyByValue = (object, value) => {
  return Object.entries(object).find(([key, val]) => val === value)?.[0];
};
function formatPercentage(value, prefix = 4) {
  const floatValue = parseFloat(value || 0);
  if (!isNaN(floatValue)) {
    const formattedPercentage = floatValue.toFixed(prefix) + "%";
    return formattedPercentage;
  } else {
    return "";
  }
}

// --- Start App Update Check ---

const checkForUpdates = async (isPrompt) => {
  handleAPI({ name: "GetGoDirectVersion", params: {}, method: "GET" })
    .then((response) => {
      response = JSON["parse"](response);
      let { latestVersion } = response["Table"][0],
        { version: appVersion } = packageJson;

      appVersion = Number(appVersion.replaceAll(".", ""));
      latestVersion = Number(latestVersion.replaceAll(".", ""));
      // console.log({ appVersion, latestVersion });

      if (latestVersion > appVersion) {
        if (isPrompt) {
          showUpdatePrompt();
        } else {
          startUpdate();
        }
      }
    })
    .catch((err) => {
      console.error("Error from GetGoDirectVersion ===> ", err);
    });
};

const showUpdatePrompt = () => {
  Alert.alert(
    "Update Available",
    "A new version of the app is available. Would you like to update?",
    [
      {
        text: "Cancel",
        style: "cancel",
      },
      {
        text: "Update",
        onPress: startUpdate,
      },
    ]
  );
};

const startUpdate = async () => {
  try {
    const storeUrl = ios
      ? "itms-apps://itunes.apple.com/app/id6458930558"
      : "market://details?id=com.directcorp.godirectmortgage";

    const supported = await Linking.canOpenURL(storeUrl);

    try {
      BackHandler.exitApp();
    } catch (error) {}

    if (supported) {
      Linking.openURL(storeUrl).catch((err) => {
        console.error("Failed to open store:", err);
        Alert.alert("Error", "Could not open the app store.");
      });
    } else {
      Alert.alert("Error", "Could not open the app store.");
    }
  } catch (e) {
    console.error("Error during update:", e);
  } finally {
  }
};

// --- End App Update Check ---

export {
  handleAPI,
  FormatPhoneLogin,
  handleOpenURL,
  validateEmail,
  log,
  handleCreateLoanOnly,
  handleSessionCheck,
  handleUserDetails,
  formatCurrency,
  roundNumber,
  cleanValue,
  numberWithCommas,
  getQueryString,
  queryStringToObject,
  updateWebURL,
  getQueryStringURL,
  removeDuplicates,
  formatDateTimeNew,
  formatSSN,
  handleStartNewLoan,
  handleGetEmpDetails,
  groupByKey,
  handleTrackGA4Events,
  isFloat,
  handleLogDWCallToActionEventParent,
  handleGetBrowserName,
  sortByKey,
  sortByKeyNumber,
  handleGetButtonText,
  handleGetStoredCredential,
  handleSetStoredCredential,
  handleCreateNewSession,
  handleCheckAlreadyLogIn,
  getNextNoYear,
  handleGetZipCodeDetails,
  handleOpenPageURL,
  generateFingerprint,
  getInitials,
  getObjectsWithKeyword,
  generateBoxShadowStyle,
  capitalizeFirstLetter,
  handleGetPlatformName,
  calculateAge,
  handleOpenScanDocFile,
  handleStructuredClone,
  handleGetSubjectPropertyAddress,
  handleGetActiveLoan,
  handleSelectLoanProgram,
  WrappedTextView,
  calculateEmploymentYears,
  convertToArrayCategory,
  testSSN,
  getKeyByValue,
  formatPercentage,
  checkForUpdates,
};
